import React, { useEffect, useState } from "react";
import DragAndDropZone from "@/components/organisms/forms/DragAndDropZone";
import { Button } from "@/components/molecules/buttons/button";
import useAnalyzeCV from "@/services/admin-services/useAnalyzeCV"; // Assurez-vous que le chemin est correct
import { Label } from "@/components/atoms/texts/label";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import ClearIcon from '@mui/icons-material/Clear';

const MultiFileUploadZone = ({ hideFileComponent, setHideFileComponent, setIsDoingAction }) => {
    const [files, setFiles] = useState([]);
    const [fileError, setFileError] = useState();
    // const [fileErrors, setFileErrors] = useState({});

    const { getAnalyzeCV, loading, error, response, resetError } = useAnalyzeCV();
    const handleUpload = async () => {
        let errors = {};

        if (files.length === 0) {
            setFileError("Veuillez sélectionner au moins un fichier.");
            return;
        }

        const updatedFiles = await Promise.all(
            files.map(async (file) => {
                const { data, error } = await getAnalyzeCV(file);

                if (error) {
                    errors[file.name] = error.message;
                    return file;
                }

                if (!data) {
                    errors[file.name] = "Erreur lors de l'analyse du CV";
                    return file;
                }

                return null;
            })
        );

        const validFiles = updatedFiles.filter(file => file !== null);
        setFiles(validFiles);
        setFileError(Object.keys(errors).length > 0 ? errors : null);
    };


    const handleFileChange = (newFiles) => {
        setFiles([...files, ...newFiles]); // Ajouter les nouveaux fichiers à la liste existante
    };

    const handleClear = () => {
        setFiles([]);
        setFileError(null);
        resetError();
    };

    useEffect(() => {
        if (response && !error) {
            setIsDoingAction(true)
            setHideFileComponent(true);
        }
    }, [response]);
    // useEffect(() => {
    //     setFileErrors(...fileErrors, error);
    // }, [error]);
    return (
        <>
            {!hideFileComponent && (
                <div className="flex flex-col gap-secondDegree p-thirdDegree">
                    <DragAndDropZone
                        file={files} // Passer la liste des fichiers
                        setFile={handleFileChange} // Fonction de mise à jour des fichiers
                        fileError={fileError}
                        isMultifiles={true}
                        accept="application/pdf"
                    />
                    <div className="flex gap-secondDegree justify-center">
                        {files.length > 0 && <Button
                            showLeftIcon={true}
                            leftIcon={<ClearIcon />}
                            text="global.actions.clear"
                            sizePadding="default"
                            style="ghost"
                            onClick={handleClear}
                            disabled={loading || files.length === 0}
                        />}
                        <Button
                            showLeftIcon={true}
                            showRightIcon={true}
                            text="global.actions.generate"
                            sizePadding="default"
                            style="ghost"
                            onClick={handleUpload}
                            disabled={loading}
                        />

                    </div>
                    {loading && <span className="loader"></span>}
                    {(fileError || error) && <Label message="error.errorCvNotUploaded" color="error" />}
                    {error && <PrintErrorMessage error={error} />}
                    {fileError && console.log("fileErrors", fileError)}
                    {response && <p className="text-green-500"> {response.status}</p>}
                    {/* {response && response} */}
                </div>
            )}
        </>
    );
};
//TODO tester la gestion des erreurs et le comportement

export default MultiFileUploadZone;
